var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "c-filter-button",
      class: _vm.classList,
      on: { click: _vm.toggleFilter }
    },
    [
      _vm._v("\n  " + _vm._s(_vm.name) + "\n  "),
      _c(
        "svg",
        {
          staticClass: "c-filter-button__icon",
          attrs: { "aria-hidden": "true", focusable: "false" }
        },
        [
          _c("use", {
            attrs: {
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              "xlink:href": "#filter"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc6a28cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc6a28cc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/_filter/filter-button/FilterButton.vue
// module id = 644
// module chunks = 0